module.exports = __webpack_public_path__ + "img/state-of-nothing.d4020bde.jpg";